import {ECOMMERCE, ANALYTICS_SOURCE_TYPES} from '@/services/analytics/constants';

function formatStoreFront(zone) {
  if (!zone || typeof zone !== 'string') {
    return null;
  }

  return `${zone.toLowerCase()} - store`;
}

function fromLocale(locale) {
  if (!locale || typeof locale !== 'object' || Array.isArray(locale)) {
    console.warn('Invalid locale data for page view:', locale);
    return {
      ecommerce: {
        storeType: ECOMMERCE.OMNI_STORE,
        storeFront: null,
        distributorNumber: null,
      },
    };
  }

  const ecommerce = {
    storeType: ECOMMERCE.OMNI_STORE,
    storeFront: formatStoreFront(locale.zone),
    distributorNumber: locale.distributorNumber?.toString() || null,
  };
  return {ecommerce};
}

export const mapPageView = (source, options = {}) => {
  if (options.sourceType === ANALYTICS_SOURCE_TYPES.LOCALE) {
    return fromLocale(source);
  }
  return source;
};
